import { z } from 'zod/v4';

/**
 * Path params for `GET /integrations/amfori/history/:syncHistoryId/report` — the
 * brand-scoped sync-report PDF. Lives in the shared contracts so the frontend
 * can build the report link (e.g. from the `AMFORI_SYNC_REPORT` in-app
 * notification) against the same shape the backend validates.
 */
export const AmforiSyncReportParamsSchema = z.object({
  syncHistoryId: z.string(),
});

export type AmforiSyncReportParams = z.infer<
  typeof AmforiSyncReportParamsSchema
>;
